/**
 * Infrastructure Monitoring Types
 * Types for PDP/PEP infrastructure status
 */

// ============================================================================
// ENUMS & CONSTANTS
// ============================================================================

export type PdpStatus = 'connected' | 'disconnected'

export type PepStatus = 'active' | 'inactive'

export type PepType = 'mssql' | 'postgres' | 'api' | 'unknown'

export const PDP_STATUS_LABELS: Record<PdpStatus, string> = {
  connected: 'Connected',
  disconnected: 'Disconnected',
}

export const PEP_STATUS_LABELS: Record<PepStatus, string> = {
  active: 'Active',
  inactive: 'Inactive',
}

export const PEP_TYPE_LABELS: Record<PepType, string> = {
  mssql: 'MSSQL',
  postgres: 'PostgreSQL',
  api: 'API',
  unknown: 'Unknown',
}

// ============================================================================
// API TYPES
// ============================================================================

export interface PepInstance {
  readonly pepId: string
  readonly pepType: PepType
  readonly status: PepStatus
  readonly lastSeen: string
  readonly metadata?: Record<string, unknown> | null
}

export interface PdpInstance {
  readonly pdpId: string
  readonly version: string
  readonly address: string
  readonly status: PdpStatus
  readonly policyCount: number
  readonly lastHeartbeat: string
  readonly registeredAt: string
  readonly peps: readonly PepInstance[]
  readonly metadata?: Record<string, unknown> | null
}

export interface InfrastructureSummary {
  readonly totalPdps: number
  readonly connectedPdps: number
  readonly totalPeps: number
  readonly activePeps: number
}

export interface InfrastructureStatus {
  readonly pdps: readonly PdpInstance[]
  readonly summary: InfrastructureSummary
}
